import natureOfBusOptions from 'src/constants/natureOfBusOptions.';

const getNatureofBus = (value) => {
  if (!value) return '';
  return Object.keys(natureOfBusOptions).find((key) => {
    return natureOfBusOptions[key] === value;
  });
};

export default getNatureofBus;
